
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexZJPUWNRuripeOLXrnJ7Z_45Zq7Lt60GEPmCptRfrwCQMYMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/index.vue?macro=true";
import { default as tokenTAUC_45_45Jdaxi86mFnibQB92lAIUr8t31uqUNO_a2oBiAMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/token.vue?macro=true";
import { default as indexEty6Uq17K_45GSVyQCPPZbr_45vMS5W6YQkwc2FUy7SZUl8Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/index.vue?macro=true";
import { default as indexQdnA5M5_457pj5ETWQeNfixiU2TVf9R16lK134tPQfr3AMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/error/index.vue?macro=true";
import { default as indexOEzlvV02x1ljiEGaKi_GE2TqtUXYOErSw1TKWw5ikFQMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/store/index.vue?macro=true";
import { default as byThemepcGfx2qri2uwSFVSxWmTtxyitSsI8Ppm2_45n4bJj6YH8Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/summary/byTheme.vue?macro=true";
import { default as bySubThemeurmHb8QSGxPa7EA7YswLPrn4omDWtlYvpB_HjDCzFbwMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/summary/bySubTheme.vue?macro=true";
import { default as byThemexPYWJhoCo4_45DMPeMjl_iSVCJ3uVerGgDLGakmgpgRrgMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/not-applicable/byTheme.vue?macro=true";
import { default as bySubTheme9bLxFSMzMVSCxIdwURJ9FqzW5QuX1zt6VaLuJ_451AqyQMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/not-applicable/bySubTheme.vue?macro=true";
import { default as world0Wmkqhch77ruZs7EZELOjmj3cODfiHXvJYVZKt5kPY4Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world.vue?macro=true";
import { default as indexKCYM1ciPzyr0Q6WidEmPnCw40OSm1BLAMWr5oWT4LMoMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/archive/index.vue?macro=true";
import { default as kpiQfp4mn84r12H7xS3DYM3eAAc_45orMXw8AaiBIBc0VuBUMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/kpi.vue?macro=true";
import { default as byTheme0v1Rv_45lDz_OWDighlP43sQRnV8vXSNoULzNgt6i2LYwMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/summary/byTheme.vue?macro=true";
import { default as bySubThemeg8cI21x_453wFOaMpJYjELmzNPsFCF5FWphiFB7DKCVj4Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/summary/bySubTheme.vue?macro=true";
import { default as byThemejQ3jJcKm6FB8rlVgZbXHYpTp4FVpPW1VsqwLmJp6QFEMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/not-applicable/byTheme.vue?macro=true";
import { default as bySubThemeiYWsuBSjVr32ObZKVwlQgWIQf2xERHHyLb2xQZ74n2UMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/not-applicable/bySubTheme.vue?macro=true";
import { default as regionGgH82Z4fa72sPZ7vSfNzGKKHdrtWoSx4e_ljC41Pr_454Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region.vue?macro=true";
import { default as indexbOyB4QPJGbrd0Y4TP_45tGoptXGssH3bfEdKKApqOHp2MMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/welcome/index.vue?macro=true";
import { default as indexmK9NGTcOT0ulcrzBwnFcTFCJapfwHcAU7SZzKftXohgMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/action-plan/index.vue?macro=true";
import { default as indexNJDC2B5wfCYtL_etil63ui64x3QCXScZl4ZFY_45Oir5wMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/choose-diag/index.vue?macro=true";
import { default as indexfQr4Tty5lAfQfKshqdG0jPUkivR_pbdF2vtbY6DJblUMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/[section]/index.vue?macro=true";
import { default as indexHJwDDbaVj4Msu8W_YDJ4KWLpEOHlOqU3ibaUa7NOyz4Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/index.vue?macro=true";
import { default as indexQKbmMKexa0jhdNabjDDvaaTaslbWIJp9RMx14Kt6q_MMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/index.vue?macro=true";
import { default as index5aB2SvsEXx7L6ICyPZ1_45sVzIbAWdGCuIaZz4_sIz5qIMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/subThemes/[subThemeId]/index.vue?macro=true";
import { default as indexb4EL0xrzIuYQFMqzgXui03BUWqBo92K9q1phLNkEb6EMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/subThemes/[subThemeId]/questions/index.vue?macro=true";
import { default as _91subThemeId_93_45JlxVFxqgb2BOpdWAc_45pcanmtIr_N61hO_45UmHqBm9FMMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/subThemes/[subThemeId].vue?macro=true";
import { default as _91themeId_93Xm8hoSVdFzSIWUIt4H_45_45jFL_EizPqbWcp5PYOGChtW4Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId].vue?macro=true";
import { default as themesbUxT2oaXUGQXJkbW2GSRCmdaZuxEBmOEo7QgKxCLE9sMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes.vue?macro=true";
import { default as indexZBCsTBPr7QIY0DtiTg2kBgfweW2r0_45Gw5ZG2iZPD6oYMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/choose-diag/index.vue?macro=true";
import { default as byThemezS1wra5VewZQuX9amWm1upkaBYst_8XspSX8nhFqHXwMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/summary/byTheme.vue?macro=true";
import { default as bySubThemeX3J_45y883jl7EI54RjgKy_45_457Anyz8avmvQwWtBGJdrcAMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/summary/bySubTheme.vue?macro=true";
import { default as byThemeZLQRH9_TiuRXm7uasvLLNI21afczJ1mAhjAPT5oy_wMMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/not-applicable/byTheme.vue?macro=true";
import { default as bySubThemeb0DG2fXmWX_45_45E24_45znbDawB_PzzCByPv37pvHQN8NIIMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/not-applicable/bySubTheme.vue?macro=true";
import { default as by_45storeBPnF47U8g0l3K1KSVtoFJUKVeiN8ZFdqU8qiW_457D3Y4Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store.vue?macro=true";
import { default as byThemeF_asftHbTSleuZzOFJJKeADuvVlfparlm2dK6J6Xu6gMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/summary/byTheme.vue?macro=true";
import { default as bySubThemeLeMCPhQXgQqjUexmWSEzZ69VhNCJUxSp6l7IjWd2YQEMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/summary/bySubTheme.vue?macro=true";
import { default as byThemei6AXSTDgc5amJPDtFuqPipvhexqTgyu26_w6ra5sqxUMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/not-applicable/byTheme.vue?macro=true";
import { default as bySubThemeeOTd7NC0s_459mgB4Y21xsqVdvl6Ai4LgkpN9gk_45_45_45tp0Meta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/not-applicable/bySubTheme.vue?macro=true";
import { default as by_45region2qpc4p6QOATA1o8sXe3HIO_S8S7QzRK5FyC3exza_45tMMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region.vue?macro=true";
import { default as indexQn5KaZyGlJrXSEtv8Z2Y3BW1osH8olZy1rhH_45qELjiUMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/[section]/setup/index.vue?macro=true";
import { default as indexJty4Ejf_45GPN8BWJDt1yMri1hwbFECMFkcskszMGRaSAMeta } from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/create/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/index.vue")
  },
  {
    name: "token",
    path: "/token",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/token.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexEty6Uq17K_45GSVyQCPPZbr_45vMS5W6YQkwc2FUy7SZUl8Meta || {},
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/index.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/error/index.vue")
  },
  {
    name: "store",
    path: "/store",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/store/index.vue")
  },
  {
    name: "report-world",
    path: "/report/world",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world.vue"),
    children: [
  {
    name: "report-world-summary-byTheme",
    path: "summary/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/summary/byTheme.vue")
  },
  {
    name: "report-world-summary-bySubTheme",
    path: "summary/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/summary/bySubTheme.vue")
  },
  {
    name: "report-world-not-applicable-byTheme",
    path: "not-applicable/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/not-applicable/byTheme.vue")
  },
  {
    name: "report-world-not-applicable-bySubTheme",
    path: "not-applicable/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/world/not-applicable/bySubTheme.vue")
  }
]
  },
  {
    name: "archive",
    path: "/archive",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/archive/index.vue")
  },
  {
    name: "report-region",
    path: "/report/region",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region.vue"),
    children: [
  {
    name: "report-region-kpi",
    path: "kpi",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/kpi.vue")
  },
  {
    name: "report-region-summary-byTheme",
    path: "summary/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/summary/byTheme.vue")
  },
  {
    name: "report-region-summary-bySubTheme",
    path: "summary/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/summary/bySubTheme.vue")
  },
  {
    name: "report-region-not-applicable-byTheme",
    path: "not-applicable/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/not-applicable/byTheme.vue")
  },
  {
    name: "report-region-not-applicable-bySubTheme",
    path: "not-applicable/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/region/not-applicable/bySubTheme.vue")
  }
]
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/welcome/index.vue")
  },
  {
    name: "action-plan",
    path: "/action-plan",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/action-plan/index.vue")
  },
  {
    name: "choose-diag",
    path: "/choose-diag",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/choose-diag/index.vue")
  },
  {
    name: "admin-section",
    path: "/admin/:section()",
    meta: indexfQr4Tty5lAfQfKshqdG0jPUkivR_pbdF2vtbY6DJblUMeta || {},
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/[section]/index.vue")
  },
  {
    name: themesbUxT2oaXUGQXJkbW2GSRCmdaZuxEBmOEo7QgKxCLE9sMeta?.name,
    path: "/eval/:diagType()/themes",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes.vue"),
    children: [
  {
    name: "eval-diagType-themes",
    path: "",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/index.vue")
  },
  {
    name: _91themeId_93Xm8hoSVdFzSIWUIt4H_45_45jFL_EizPqbWcp5PYOGChtW4Meta?.name,
    path: ":themeId()",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId].vue"),
    children: [
  {
    name: "eval-diagType-themes-themeId",
    path: "",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/index.vue")
  },
  {
    name: _91subThemeId_93_45JlxVFxqgb2BOpdWAc_45pcanmtIr_N61hO_45UmHqBm9FMMeta?.name,
    path: "subThemes/:subThemeId()",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/subThemes/[subThemeId].vue"),
    children: [
  {
    name: "eval-diagType-themes-themeId-subThemes-subThemeId",
    path: "",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/subThemes/[subThemeId]/index.vue")
  },
  {
    name: "eval-diagType-themes-themeId-subThemes-subThemeId-questions",
    path: "questions",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/themes/[themeId]/subThemes/[subThemeId]/questions/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "admin-choose-diag",
    path: "/admin/choose-diag",
    meta: indexZBCsTBPr7QIY0DtiTg2kBgfweW2r0_45Gw5ZG2iZPD6oYMeta || {},
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/choose-diag/index.vue")
  },
  {
    name: "report-country-by-store",
    path: "/report/country/by-store",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store.vue"),
    children: [
  {
    name: "report-country-by-store-summary-byTheme",
    path: "summary/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/summary/byTheme.vue")
  },
  {
    name: "report-country-by-store-summary-bySubTheme",
    path: "summary/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/summary/bySubTheme.vue")
  },
  {
    name: "report-country-by-store-not-applicable-byTheme",
    path: "not-applicable/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/not-applicable/byTheme.vue")
  },
  {
    name: "report-country-by-store-not-applicable-bySubTheme",
    path: "not-applicable/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-store/not-applicable/bySubTheme.vue")
  }
]
  },
  {
    name: "report-country-by-region",
    path: "/report/country/by-region",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region.vue"),
    children: [
  {
    name: "report-country-by-region-summary-byTheme",
    path: "summary/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/summary/byTheme.vue")
  },
  {
    name: "report-country-by-region-summary-bySubTheme",
    path: "summary/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/summary/bySubTheme.vue")
  },
  {
    name: "report-country-by-region-not-applicable-byTheme",
    path: "not-applicable/byTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/not-applicable/byTheme.vue")
  },
  {
    name: "report-country-by-region-not-applicable-bySubTheme",
    path: "not-applicable/bySubTheme",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/report/country/by-region/not-applicable/bySubTheme.vue")
  }
]
  },
  {
    name: "admin-section-setup",
    path: "/admin/:section()/setup",
    meta: indexQn5KaZyGlJrXSEtv8Z2Y3BW1osH8olZy1rhH_45qELjiUMeta || {},
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/admin/[section]/setup/index.vue")
  },
  {
    name: "eval-diagType-create",
    path: "/eval/:diagType()/create",
    component: () => import("/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/app/pages/eval/[diagType]/create/index.vue")
  }
]